import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import CK from '../store/modules/CK.js'
// import state from './defultState.js'



export default new Vuex.Store({
  modules:{//模块化
      CK
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js